import { nowInstant, toInstant } from './temporalUtils';

/**
 * Calculates the remaining time (in milliseconds).
 *
 * @param {string | Date} startDate - The start timestamp.
 * @param {number} timeLimitInMinutes - The time limit in minutes.
 * @returns {number} The remaining time in milliseconds.
 */
export function calculateRemainingTime(startDate: Date | string, timeLimitInMinutes: number): number {
  const now = nowInstant();

  // startDate can be ISO datetime string or Date object
  const createdAt = toInstant(startDate);

  const durationSinceCreation = now.since(createdAt);
  const minutesSinceCreation = durationSinceCreation.total('minutes');

  const timeRemainingInMinutes = timeLimitInMinutes - minutesSinceCreation;

  return timeRemainingInMinutes > 0 ? timeRemainingInMinutes * 60 * 1000 : 0;
}
